import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import authSlice, { sessionExpired } from '../features/auth/authSlice';
import { registerAuthFailureHandler } from '../interceptors/axios';
import isIdyaResult from '../helpers/isIdyaResult';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authSlice
  },
});

// 401 sonrası refresh de başarısız olursa (refresh token geçersiz/süresi dolmuş)
// interceptor buraya düşer: oturum kapatılır, uygulama login ekranına geçer.
registerAuthFailureHandler((reason) => {
  const message = isIdyaResult(reason) ? reason.errors[0] : undefined;
  store.dispatch(sessionExpired(message || undefined));
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
